export function Brand({ size = "md" }) {
  const heights = { sm: "h-16", md: "h-14", lg: "h-28" };
  return (
    <img
      src="/logo.png"
      alt="MyFriendRent · Rental Management Platform"
      className={`${heights[size]} w-auto object-contain select-none`}
      data-testid="brand-logo"
      draggable={false}
    />
  );
}
